<template>
  <div class="view-wrapper">
    <div class="view">
      <v-card>
        <v-card-title style="padding: 4px 16px">
          <h6>Фильтр</h6>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row dense>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="filter.startDate"
                  label="С"
                  type="date"
                  required
                  clearable

                  @keydown.enter="fetchItems"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="filter.endDate"
                  label="По"
                  type="date"
                  required
                  clearable

                  @keydown.enter="fetchItems"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="2">
                <v-autocomplete
                  v-model="filter.number"
                  :items="ctx.src.contracts.items"
                  :label="'Номер договора'"
                  item-text="number"
                  item-value="number"
                  clearable
                  @keydown.enter="fetchItems"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="2">
                <v-autocomplete
                v-model="filter.fullName"
                :items="ctx.src.org.items"
                :label="'Название организации'"
                item-text="fullName"
                item-value="fullName"
                clearable
                @keydown.enter="fetchItems"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" small @click="fetchItems">
            Применить
          </v-btn>
          <v-btn small @click="resetFilter">
            Сбросить
          </v-btn>
          <v-spacer />
          <v-btn
            color="green"
            :loading="exporting"
            :disabled="items.length === 0"
            small
            class="white--text"
            @click="exp"
          >
            Экспорт
            <v-icon right dark>
              cloud_download
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        :single-select="true"
        item-key="id"
        hide-default-footer
        :loading="loading"
        loading-text="Загрузка... Пожалуйста подождите"
        fixed-header
      >

      </v-data-table>
    </div>
  </div>
</template>

<script>

import dateIsoFilter from "@/filters/dateIso.filter";
import js2vm from "@/utils/js2vm";
import ctx from "@/ctx";
import fetch from "@/utils/fetch";
import vm2js from "@/utils/vm2js";

let Filter = function() {
  let self = this;

  let startDate = new Date();
  startDate.setDate(startDate.getDate() - 30);
  self.startDate = dateIsoFilter(startDate);
  self.endDate = dateIsoFilter(new Date());
  self.number = undefined;
  self.fullName = undefined;
};


let Item = function(d) {
  let self = this;

  js2vm(self, d);
  self.startDate = dateIsoFilter(d.startDate);
  self.endDate = dateIsoFilter(d.endDate);

}

let Report = function(d) {
  let self = this;

  self.title = d.title;
  self.subtitle = d.subtitle;
  self.rowDtos = [];

  d.rowDtos.forEach(i => {
    self.rowDtos.push(new Item(i));
  });
};

export default {
  data: () => ({
    ctx,
    selected: [],
    loading: false,
    headers: [
      {
        text: "Клиент",
        align: "start",
        sortable: false,
        value: "fullName"
      },
      {
        text: "№ договора",
        sortable: false,
        value: "number"
      },
      {
        text: "Страховая",
        sortable: false,
        value: "insuranceName"
      },
      {
        text: "Дата с",
        sortable: false,
        value: "startDate"
      },
      {
        text: "Дата по",
        sortable: false,
        value: "endDate"
      },
      {
        text: "Программа",
        sortable: false,
        value: "name"
      },
      {
        text: "Количество ОД",
        sortable: false,
        value: "mainInsured"
      },
      {
        text: "Количество ЧС",
        sortable: false,
        value: "attachedInsured"
      },
      {
        text: "Выплаты",
        sortable: false,
        value: "sum"
      },
      {
        text: "Выплаты total",
        sortable: false,
        value: "sumWithSurcharge"
      },
      {
        text: "Объединенный лимит(стоп/мед)",
        sortable: false,
        value: "unionLimit"
      },
      {
        text: "Тип категории(стом/мед)",
        sortable: false,
        value: "restrictionType"
      },
      {
        text: "Лимит стоматологии",
        sortable: false,
        value: "stomLimit"
      },
      {
        text: "Лимит медикаментов",
        sortable: false,
        value: "medLimit"
      },
      {
        text: "Лимит ИФА/ПЦР",
        sortable: false,
        value: "ifapcrLimit"
      },
      {
        text: "Лимит КТ/МРТ",
        sortable: false,
        value: "ktmrtLimit"
      },
      {
        text: "Траты стоматология",
        sortable: false,
        value: "stomSpends"
      },
      {
        text: "Траты медикаменты",
        sortable: false,
        value: "medSpends"
      },
      {
        text: "Траты ИФА/ПЦР",
        sortable: false,
        value: "ifapcrSpends"
      },
      {
        text: "Траты КТ/МРТ",
        sortable: false,
        value: "ktmrtSpends"
      }
    ],
    report: {},
    filter: new Filter(),
    items: [],
    exporting: false
  }),
  methods: {
    resetFilter() {
      this.filter = new Filter();
    },
    async exp() {
      this.exporting = true;
      const res = await fetch.post(
        "/api/report/underwriting/export",
        vm2js(this.report)
      );
      if (res) {
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(await res.blob);
        link.download = res.filename;
        link.click();
      }
      this.exporting = false;
    },
    async fetchItems() {
      this.loading = true;
      this.items = [];
      console.log(this.filter);
      let res = await fetch.post(
        "/api/report/underwriting/get",
        vm2js(this.filter)
      );
      console.log("RES");
      console.log(res);
      if (res) {
        this.report = new Report(res);
        res.rowDtos.forEach(r => {
          if(r?.sum){
            this.items.push(new Item(r));
          }
        });
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped>

</style>
